import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from '../ui/dialog';
import { Star } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const StarRating = ({ value, onChange }) => (
  <div className="flex gap-1">
    {[1, 2, 3, 4, 5].map((n) => (
      <button
        type="button"
        key={n}
        onClick={() => onChange(n)}
        className="focus:outline-none"
      >
        <Star className={`h-6 w-6 ${n <= value ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'}`} />
      </button>
    ))}
  </div>
);

const FIELDS = [
  ['nota_conteudo', 'Conteúdo do curso'],
  ['nota_instrutor', 'Instrutor / didática'],
  ['nota_aplicabilidade', 'Aplicabilidade no trabalho'],
  ['nota_geral', 'Avaliação geral'],
];

const ReactionSurveyDialog = ({ open, onOpenChange, courseId, courseTitle, onSubmitted }) => {
  const [ratings, setRatings] = useState({
    nota_conteudo: 0, nota_instrutor: 0, nota_aplicabilidade: 0, nota_geral: 0,
  });
  const [recomendaria, setRecomendaria] = useState(null);
  const [comentario, setComentario] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (ratings.nota_geral === 0) {
      toast.error('Dê ao menos a avaliação geral');
      return;
    }
    try {
      setSubmitting(true);
      await axios.post(`${API}/api/lms/cursos/${courseId}/pesquisa-reacao`, {
        course_id: courseId,
        ...ratings,
        recomendaria,
        comentario,
      });
      toast.success('Obrigado pela sua avaliação!');
      if (onSubmitted) onSubmitted();
      onOpenChange(false);
    } catch (e) {
      toast.error('Erro ao enviar avaliação');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Pesquisa de Reação</DialogTitle>
          <DialogDescription>
            Avalie sua experiência no curso{courseTitle ? `: ${courseTitle}` : ''}.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          {FIELDS.map(([key, label]) => (
            <div key={key} className="flex items-center justify-between">
              <Label>{label}</Label>
              <StarRating value={ratings[key]} onChange={(v) => setRatings({ ...ratings, [key]: v })} />
            </div>
          ))}
          <div>
            <Label>Você recomendaria este curso?</Label>
            <div className="flex gap-2 mt-1">
              <Button type="button" size="sm" variant={recomendaria === true ? 'default' : 'outline'} onClick={() => setRecomendaria(true)}>Sim</Button>
              <Button type="button" size="sm" variant={recomendaria === false ? 'default' : 'outline'} onClick={() => setRecomendaria(false)}>Não</Button>
            </div>
          </div>
          <div>
            <Label>Comentário (opcional)</Label>
            <Textarea value={comentario} onChange={(e) => setComentario(e.target.value)} />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Agora não</Button>
          <Button onClick={handleSubmit} disabled={submitting}>{submitting ? 'Enviando...' : 'Enviar avaliação'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ReactionSurveyDialog;
